import React from "react";
import "./Chip.css";

type ChipProps = {
  type?: string;
  id?: string;
  class?: string;
  children: React.ReactNode;
  callback?: (event?: any) => void;
  onMouseEnter?: (event?: any) => void;
  onMouseLeave?: (event?: any) => void;
  k?: string;
};

export function Chip(props: ChipProps) {
  const baseClass = () => {
    switch (props.type) {
      case "button":
        return "chipButton";
      default:
        return "chipDefault";
    }
  };

  return (
    <div
      id={props.id}
      className={`chip ${baseClass()} ${props.class}`}
      onClick={props.callback}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      key={props.k}
    >
      {props.children}
    </div>
  );
}
